import * as React from 'react';
import { Opgavepakke } from '../../models/Opgavepakke';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Form, Col, Row } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Section } from '../../uiComponents/layout/Section';
import {
    TextFormGroup,
    MenuItemDto,
    DatePickerFormGroup
} from '../../uiComponents/input/FormGroups';
import { ValidationError, getValidationErrorsForCollection, ValidationResult } from '../../infrastructure/ValidationResult';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { LinkSecondaryButton } from '../../uiComponents/input/Buttons';
import { SkoleaarDropdown } from '../../uiComponents/input/SkoleaarDropDown';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { OpgaveListItem } from '../../models/OpgaveListItem';
import { OpgavepakkeOpgave } from '../../models/OpgavepakkeOpgave';
import OpgavepakkeOpgavePresenter from './OpgavepakkeOpgavePresenter';
import Autocomplete from '../../uiComponents/input/Autocomplete';
import { Logbog } from '../../models/Logbog';
import { Guid } from '../../infrastructure/Guid';
import * as FlipMove from 'react-flip-move';
import { EditorStateModel } from '../../models/EditorStateModel';
import OpgavePakkeVejledningContainer from '../opgavepakke/OpgavepakkeVejledningContainer';
import { EditorState } from 'draft-js';

export interface OpgavepakkePresenterProps {
    opgavepakke: Opgavepakke;
    errorMessages: ValidationError[];
    isSubmitting: boolean;
    isSaved: boolean;
    editorStates: EditorStateModel[];
    validationResult: ValidationResult;
    opgaver: OpgaveListItem[];
    logboeger: Logbog[];
    onSave: () => void;
    onChange: (fieldName: string, value: any) => void;
    opretRediger: 'Opret' | 'Rediger';
    onAfsnitRemoved: (index: number) => void;
    onAddAfsnit: () => void;
    onVejledningChanged: (index: number, fieldname: string, value: any) => void;
    onEditorChanged: (index: number, editorState: EditorState) =>  void;
}

class OpgavepakkePresenter extends React.Component<OpgavepakkePresenterProps, any> {
    constructor(props: OpgavepakkePresenterProps) {
        super(props);

        this.onOpgaveAdded = this.onOpgaveAdded.bind(this);
        this.onOpgaveRemoved = this.onOpgaveRemoved.bind(this);
        this.onTilknyttetOpgaveChanged = this.onTilknyttetOpgaveChanged.bind(this);
    }

    onOpgaveRemoved(index: number) {
        this.props.opgavepakke.opgavepakkeOpgaver.splice(index, 1);
        this.props.onChange('opgavepakkeOpgaver', this.props.opgavepakke.opgavepakkeOpgaver);
    }

    onTilknyttetOpgaveChanged(fieldName: string, value: any, index: number) {
        this.props.opgavepakke.opgavepakkeOpgaver[index][fieldName] = value;
        this.props.onChange('opgavepakkeOpgaver', this.props.opgavepakke.opgavepakkeOpgaver);
    }

    onOpgaveAdded(name: string, value: any[]) {
        let opgavepakkeOpgave = new OpgavepakkeOpgave();
        opgavepakkeOpgave.uiId = Guid.newGuid();
        opgavepakkeOpgave.logbogId = '00000000-0000-0000-0000-000000000000';
        opgavepakkeOpgave.opgaveId = value[0];
        opgavepakkeOpgave.opgavetitel = this.props.opgaver.filter(o => o.id === value[0])[0].titel;
        opgavepakkeOpgave.order = this.props.opgavepakke.opgavepakkeOpgaver.length; // ToDo JMG: overvej at flytte til backend, da slet af afsnit midt i, potentielt forårsager afsnit med samme order
        this.props.opgavepakke.opgavepakkeOpgaver.push(opgavepakkeOpgave);
        this.props.onChange('opgavepakkeOpgaver', this.props.opgavepakke.opgavepakkeOpgaver);
    }

    render() {
        let opgaveListItems = this.props.opgaver.map(o =>
            new MenuItemDto(o.id, o.titel)
        );

        let tilknyttedeOpgaver = this.props.opgavepakke.opgavepakkeOpgaver.map((o, i) => {
            let validationErrors = getValidationErrorsForCollection(this.props.errorMessages, 'opgavepakkeOpgaver', i);

            return (

                <OpgavepakkeOpgavePresenter
                    index={i}
                    key={o.uiId}
                    opgavepakkeOpgave={o}
                    logboeger={this.props.logboeger}
                    onRemoveOpgave={this.onOpgaveRemoved}
                    onChange={this.onTilknyttetOpgaveChanged}
                    errorMessages={validationErrors}
                />

            );
        });

        const tilknyttedeOpgaverFlipMove = (
            <FlipMove enterAnimation='accordionVertical' leaveAnimation='accordionVertical'>
                {tilknyttedeOpgaver}
            </FlipMove>
        );

        return (
            <PageWrapper>
                <PageTitle title={'Opgavepakker'} />
                <ContentWrapper>
                    <SectionGroup header={this.props.opretRediger + ' opgavepakke'}>
                        <Form onSubmit={this.props.onSave}>
                            <Section>
                                <Row>
                                    <Col md={6} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.props.errorMessages}
                                            label='Titel*'
                                            name='titel'
                                            placeholder='Skriv titel'
                                            value={this.props.opgavepakke.titel}
                                            onChange={this.props.onChange}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3} mdOffset={3}>
                                        <SkoleaarDropdown
                                            onChange={this.props.onChange}
                                            selectedValue={this.props.opgavepakke.skoleaar}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <DatePickerFormGroup
                                            errorMessages={this.props.errorMessages}
                                            label='Synlig fra'
                                            name='synligFraDato'
                                            value={this.props.opgavepakke.synligFraDato}
                                            onChange={this.props.onChange}
                                        />
                                    </Col>
                                </Row>
                            </Section>
                            {tilknyttedeOpgaverFlipMove}
                            <Section>

                                <Row>
                                    <Col md={6} mdOffset={3}>
                                        <Autocomplete
                                            errorMessages={this.props.errorMessages}
                                            label='Tilføj opgave'
                                            name='opgaver'
                                            selected={[]}
                                            onChange={this.onOpgaveAdded}
                                            data={opgaveListItems}
                                            placeholder='Find opgave'
                                            clearAfterSelect={true}
                                        />
                                    </Col>

                                </Row>
                            </Section>
                            <Section>
                                <Row>
                                    <Col md={12} mdOffset={0}>
                                        <OpgavePakkeVejledningContainer
                                            editorStates={this.props.editorStates}
                                            vejledning={this.props.opgavepakke.vejledning}
                                            validationResult={this.props.validationResult}
                                            isSubmitting={this.props.isSubmitting}
                                            isSaved={this.props.isSaved}
                                            onAddAfsnit={this.props.onAddAfsnit}
                                            onAfsnitRemoved={this.props.onAfsnitRemoved}
                                            onEditorChanged={this.props.onEditorChanged}
                                            onVejledningChanged={this.props.onVejledningChanged}
                                        />
                                    </Col>
                                </Row>
                            </Section>
                            <ButtonSection>
                                <LinkSecondaryButton className='spacer' url={'/opgavepakker'} text='Fortryd' />
                                <SubmitButton isSubmitting={this.props.isSubmitting}>{this.props.opretRediger === 'Opret' ? 'Opret' : 'Gem ændringer'}</SubmitButton>
                            </ButtonSection>
                        </Form>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default OpgavepakkePresenter;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgavepakke/OpgavepakkePresenter.tsx